import { apiGet, apiPost } from './api';

function getStoredAdminUserId(): string | null {
	if (typeof window === 'undefined') return null;
	try {
		const raw = window.sessionStorage.getItem('gardenhub:auth');
		if (!raw) return null;
		const user = JSON.parse(raw) as { id?: string | number } | null;
		return user?.id != null ? String(user.id) : null;
	} catch {
		return null;
	}
}

export type ModerationTargetType = 'plan' | 'offer' | 'project' | 'user';
export type ModerationStatusFilter = 'all' | 'active' | 'hidden' | 'deleted';

export interface ModerationItem {
	id: number;
	targetType: ModerationTargetType;
	title: string;
	subtitle: string | null;
	imageUrl?: string | null;
	ownerUserId?: number | null;
	planId?: number | null;
	entityStatus: string | null;
	moderationStatus: string | null;
	createdAt: string;
	openReportCount: number;
}

export interface ModerationListResponse {
	items: ModerationItem[];
	pagination: {
		total: number;
		limit: number;
		offset: number;
		has_more: boolean;
	};
}

export async function listModerationItems(params: {
	target_type: ModerationTargetType;
	query?: string;
	status?: ModerationStatusFilter;
	limit?: number;
	offset?: number;
}): Promise<ModerationListResponse> {
	const search = new URLSearchParams();
	search.set('target_type', params.target_type);
	if (params.query) search.set('query', params.query);
	if (params.status && params.status !== 'all') search.set('status', params.status);
	if (typeof params.limit === 'number') search.set('limit', String(params.limit));
	if (typeof params.offset === 'number') search.set('offset', String(params.offset));
	const userId = getStoredAdminUserId();
	if (userId) search.set('userId', userId);
	return apiGet<ModerationListResponse>(`/admin/moderation?${search.toString()}`);
}

export async function moderateItemAction(
	targetType: ModerationTargetType,
	targetId: number,
	payload: {
		action: 'soft_delete' | 'restore' | 'hide' | 'unhide';
		admin_user_id: number;
		reason?: string;
	}
): Promise<{ ok: boolean }> {
	return apiPost<{ ok: boolean }>(`/admin/moderation/${targetType}/${targetId}/action`, payload);
}

